import { ACTIONS_TYPES, TriggerbeeTagActions } from 'app/automations/automation-helpers-actions';
import { CustomModelAction, CustomModelProperty, TypeInput } from 'app/automations/automations-models';

// Not in PROPS_TYPE, which only covers the plural ESP tag fields.
export const TAG_PROP_NAME = 'tag';

export function isTriggerbeeTagAction(action: CustomModelAction | undefined): boolean {
  return !!action && TriggerbeeTagActions.includes(action.$type as ACTIONS_TYPES);
}

export function isTagProfileSwitch(action: CustomModelAction | undefined, prop: CustomModelProperty): boolean {
  return isTriggerbeeTagAction(action) && prop?.typeInput === TypeInput.Switch;
}
